import { connect } from 'react-redux';
import { IState } from '../../store/index';

import { IOfferBreadcrumbsProps, OfferBreadcrumbs } from './index';

function mapStateToProps(state: IState): IOfferBreadcrumbsProps {
  return {
    breadcrumbs: state.offerData.breadcrumbs,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OfferBreadcrumbsContainer = connect<IOfferBreadcrumbsProps, any, any>(mapStateToProps)(OfferBreadcrumbs);
